<app-side-menu>
  <div class="users-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="profileFilter" class="form-label">Filtrar por Perfil:</label>
          <select
            id="profileFilter"
            class="form-select"
            [ngModel]="filters.profileId"
            (ngModelChange)="filters.profileId = $event; applyFilters()">
            <option value="">Todos os perfis</option>
            <option *ngFor="let profile of profiles" [value]="profile.id">
              {{ profile.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select
            id="statusFilter"
            class="form-select"
            [ngModel]="filters.active"
            (ngModelChange)="filters.active = $event; applyFilters()">
            <option value="">Todos os Status</option>
            <option value="true">Apenas Ativos</option>
            <option value="false">Apenas Inativos</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="employeeTypeFilter" class="form-label">Tipo de Contrato:</label>
          <select
            id="employeeTypeFilter"
            class="form-select"
            [ngModel]="filters.employeeType"
            (ngModelChange)="filters.employeeType = $event; applyFilters()">
            <option value="">Todos os tipos</option>
            <option value="CLT">CLT</option>
            <option value="PJ">PJ</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="clientFilter" class="form-label">Tipo de Usuário:</label>
          <select
            id="clientFilter"
            class="form-select"
            [ngModel]="filters.isClient"
            (ngModelChange)="filters.isClient = $any($event); applyFilters()">
            <option value="">Todos</option>
            <option value="true">Apenas Clientes</option>
            <option value="false">Apenas Funcionários</option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-outline-secondary me-2"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="navigateToNewUser()">
            <i class="fas fa-user-plus me-2"></i>
            Novo Usuário
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Usuários -->
    <div *ngIf="!loading && !error && filteredUsers.length > 0">
      <app-table
        [title]="'Lista de Usuários'"
        [data]="filteredUsers"
        [searchRight]="true"
        [columns]="columns"
        [showSearch]="true"
        [searchPlaceholder]="'Buscar por nome, email, ID...'"
        [clickable]="false"
        [actions]="actions"
        [disablePagination]="false"
        [totalItemsFromBackend]="totalItems"
        [itemsPerPage]="pageSize"
        [currentPageFromBackend]="currentPage"
        [hasNextPageFromBackend]="hasNextPage"
        [hasPreviousPageFromBackend]="hasPreviousPage"
        (searchChange)="onSearchChange($any($event))"
        (actionClick)="onActionClick($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!loading && !error && filteredUsers.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-users"></i>
        <p>Nenhum usuário encontrado</p>
      </div>
    </div>

    <!-- Loading -->
    <app-loading
      [show]="loading"
      [message]="'Carregando usuários...'"
      [size]="'medium'"
      [overlay]="true">
    </app-loading>

    <!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="refreshUsers()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>

  <!-- Modal de Visualização de Usuário -->
  <app-user-view-modal
    [show]="showUserModal"
    [user]="selectedUser"
    (closeModal)="closeViewModal()">
  </app-user-view-modal>
</app-side-menu>